export default "__VITE_ASSET__d$4yBVBr__"